import { render, staticRenderFns } from "./SvgNav.vue?vue&type=template&id=6d965b72&scoped=true&"
import script from "./SvgNav.vue?vue&type=script&lang=js&"
export * from "./SvgNav.vue?vue&type=script&lang=js&"
import style0 from "./SvgNav.vue?vue&type=style&index=0&id=6d965b72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d965b72",
  null
  
)

export default component.exports